import { Typography } from "@mui/material";
import "./styles.css";
import dolphinIcon from "@assets/dolphin-icon.png";

const NotFound = () => {
  return (
    <div className="not_found_page_root__div">
      <Typography
        variant="h2"
        sx={{
          color: "secondary.contrastText",
        }}
      >
        Not found!
      </Typography>
      <img className="not_found_page_logo__img" src={dolphinIcon} />
      <div className="not_found_page_subtext__div">
        <Typography
          sx={{
            color: "secondary.contrastText",
          }}
        >
          Either the URL you provided is faulty or Dolphin couldn't resolve the
          route properly.
        </Typography>
      </div>
    </div>
  );
};

export default NotFound;
